<section class="home-hps-card-component-wrapper">
  <div class="home-hps-card-component-wrapper_headline-w">
    <h2>{{'home-page.hps-headline' | translate}}</h2>
    <p>{{'home-page.hps-text' | translate}}</p>
  </div>

  <div class="home-hps-card-component-wrapper_img-text-w">
    <div class="home-hps-card-component-wrapper_img-text-w_image">
      <img src="../../../../assets/images/home-page/hps-mobile-img.png" alt="hps mobile image"/>
    </div>

    <div class="home-hps-card-component-wrapper_img-text-w_text">
      <h3>{{'home-page.hps-features' | translate}}</h3>

      <app-heading-text-wrapper
        [headingText]="'home-page.hps-epatient-headline' | translate"
        [bodyText]="'home-page.hps-epatient-text' | translate"
      />

      <app-heading-text-wrapper
        [headingText]="'home-page.hps-eMedical-record-headline' | translate"
        [bodyText]="'home-page.hps-eMedical-record-text' | translate"
      />

      <app-heading-text-wrapper
        [headingText]="'home-page.hps-accounting-headline' | translate"
        [bodyText]="'home-page.hps-accounting-text' | translate"
      />

      <app-heading-text-wrapper
        [headingText]="'home-page.hps-eLab-headline' | translate"
        [bodyText]="'home-page.hps-eLab-text' | translate"
      />
    </div>
  </div>

  <div class="home-hps-card-component-wrapper_hps-btn-w">
    <app-button
      [label]="'home-page.hps-learn-more' | translate"
      (clickEvent)="openHpsInNewTab()"
    />
  </div>
</section>
